<div class="mass-os-it-services">
  <div class="mass-os-it-services__toolbar">
    <span class="mass-os-it-services__count" *ngIf="selectedCount > 0">
      {{ selectedCount }} servicio{{ selectedCount === 1 ? '' : 's' }}
      seleccionado{{ selectedCount === 1 ? '' : 's' }} para OS
    </span>
  </div>

  <table
    mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mass-os-it-services__table"
  >
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-services__expand"></th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__expand">
        <button
          *ngIf="isTicketService(servicio)"
          type="button"
          mat-icon-button
          class="mass-os-it-services__chevron"
          [attr.aria-expanded]="isServiceExpanded(servicio)"
          [attr.aria-label]="
            (isServiceExpanded(servicio) ? 'Contraer ' : 'Expandir ') +
            servicio.nombreServicio
          "
          (click)="toggleServiceExpand(servicio)"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="Check">
      <th mat-header-cell *matHeaderCellDef class="mass-os-it-services__check"></th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__check">
        <mat-checkbox
          *ngIf="showServiceCheck(servicio)"
          [checked]="isSelected(servicio.id)"
          [indeterminate]="isServiceIndeterminate(servicio)"
          [disabled]="isServiceBlockedForOs(servicio)"
          [matTooltip]="
            isServiceBlockedForOs(servicio)
              ? 'Servicio de catálogo SSFF — no genera OS'
              : ''
          "
          (change)="onToggle(servicio.id, $event.checked)"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </td>
    </ng-container>

    <!-- Sticker de origen: SSFF / ADD / UPGRADE -->
    <ng-container matColumnDef="origin">
      <th mat-header-cell *matHeaderCellDef>{{ headers.origin }}</th>
      <td
        mat-cell
        *matCellDef="let servicio"
        class="mass-os-it-services__origin"
      >
        <span
          *ngIf="originLabel(servicio)"
          class="mass-os-it-services__origin-badge"
          [ngClass]="'mass-os-it-services__origin-badge--' + serviceOrigin(servicio)"
          [matTooltip]="originHint(servicio)"
          matTooltipPosition="right"
        >
          {{ originLabel(servicio) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="serviceDay">
      <th mat-header-cell *matHeaderCellDef>{{ headers.serviceDay }}</th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__center">
        <span class="mass-os-it-services__day">{{ servicio.serviceDay }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="fecha">
      <th mat-header-cell *matHeaderCellDef>{{ headers.fecha }}</th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__center">
        {{ servicio.fecha | date: 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="tipoServicio">
      <th mat-header-cell *matHeaderCellDef>{{ headers.tipoServicio }}</th>
      <td
        mat-cell
        *matCellDef="let servicio"
        class="mass-os-it-services__tipo"
      >
        <span class="mass-os-it-services__tipo-shell">
          <i-tabler
            [name]="tipoIcon(servicio.tipoServicio)"
            class="mass-os-it-services__tipo-icon"
            aria-hidden="true"
          ></i-tabler>
        </span>
        <span class="mass-os-it-services__tipo-label">{{
          servicio.tipoServicio
        }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nombreServicio">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mass-os-it-services__activity"
      >
        {{ headers.nombreServicio }}
      </th>
      <td
        mat-cell
        *matCellDef="let servicio"
        class="mass-os-it-services__activity"
      >
        <span class="mass-os-it-services__activity-name">{{
          servicio.nombreServicio
        }}</span>
        <span
          *ngIf="isTicketService(servicio) && ticketCountFor(servicio.id) > 0"
          class="mass-os-it-services__ticket-badge"
          title="Tickets seleccionados para OS"
        >
          <mat-icon>confirmation_number</mat-icon>
          {{ ticketCountFor(servicio.id) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>{{ headers.nombre }}</th>
      <td
        mat-cell
        *matCellDef="let servicio"
        class="mass-os-it-services__provider"
      >
        {{ servicio.nombre }}
      </td>
    </ng-container>

    <ng-container matColumnDef="moneda">
      <th mat-header-cell *matHeaderCellDef>{{ headers.moneda }}</th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__center">
        <span class="mass-os-it-services__moneda">{{ servicio.moneda }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="pax">
      <th mat-header-cell *matHeaderCellDef>{{ headers.pax }}</th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__center">
        <span class="mass-os-it-services__metric">
          <span
            class="table-icon-shell metric-button"
            [ngClass]="
              paxOf(servicio) > 0 ? 'tone-success' : 'tone-warning'
            "
          >
            <i-tabler name="users" class="mass-os-it-services__metric-icon"></i-tabler>
            <span class="table-metric-badge">{{ paxOf(servicio) }}</span>
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="personal">
      <th mat-header-cell *matHeaderCellDef>{{ headers.personal }}</th>
      <td mat-cell *matCellDef="let servicio" class="mass-os-it-services__center">
        <span class="mass-os-it-services__metric">
          <span
            class="table-icon-shell metric-button"
            [ngClass]="
              personalOf(servicio) > 0 ? 'tone-success' : 'tone-empty'
            "
          >
            <i-tabler
              name="user-check"
              class="mass-os-it-services__metric-icon"
            ></i-tabler>
            <span class="table-metric-badge">{{
              personalOf(servicio)
            }}</span>
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="costo">
      <th mat-header-cell *matHeaderCellDef>{{ headers.costo }}</th>
      <td mat-cell *matCellDef="let servicio">
        <span class="mass-os-it-services__costo">
          {{ servicio.costo | formatNumber }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let servicio"
        [attr.colspan]="displayedColumns.length"
        [ngClass]="
          isServiceExpanded(servicio)
            ? 'mass-os-it-services__detail-cell--open'
            : 'mass-os-it-services__detail-cell'
        "
      >
        <app-mass-os-ticket-expand
          *ngIf="
            isServiceExpanded(servicio) && isTicketService(servicio)
          "
          [service]="servicio"
          [selectedTickets]="selectedTickets"
          (ticketToggle)="ticketToggle.emit($event)"
        ></app-mass-os-ticket-expand>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="mass-os-it-services__row"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="mass-os-it-services__detail-row"
    ></tr>
  </table>

  <mat-paginator
    *ngIf="dataSource.data.length > 10"
    [pageSize]="10"
    [pageSizeOptions]="[10, 20, 50]"
    [showFirstLastButtons]="true"
    aria-label="Paginación de servicios"
    (page)="onPageChange()"
  ></mat-paginator>
</div>
